export const BUSINESS_TRAVELLER_BUSINESS_EMPLOYEE_COUNT_OPTIONS: Array<[App.BusinessTraveller.BusinessEmployeeCountOptions, string]> = [
  ['1-5', '1-5'],
  ['6-20', '6-20'],
  ['21-50', '21-50'],
  ['51-200', '51-200'],
  ['200+', '200+'],
]

export const SMALL_TEAM_OPTIONS: Array<App.BusinessTraveller.BusinessEmployeeCountOptions> = ['1-5', '6-20']

export function isSmallTeam(employeeCount: string): boolean {
  return SMALL_TEAM_OPTIONS.includes(employeeCount as App.BusinessTraveller.BusinessEmployeeCountOptions)
}
